// Meta Pixel helpers. Base code is server-rendered in public/index.html <head>.
import axios from 'axios';

const PIXEL_ID = '1053912930743560';

function ready() {
  // The base-code stub exists immediately, but only queues calls once init has run.
  return typeof window.fbq === 'function';
}

function dispatch(event, params, options) {
  window.fbq('track', event, params, options);
  const log = (window.__dysscPixel = window.__dysscPixel || []);
  log.push({ event, params, options, at: new Date().toISOString() });
  // eslint-disable-next-line no-console
  console.log('[pixel] tracked', event, params, options);
}

export function fbTrack(event, params = {}, options = {}) {
  try {
    if (ready()) { dispatch(event, params, options); return; }
    // fbevents.js hasn't parsed yet (slow network / early click): retry briefly.
    // eslint-disable-next-line no-console
    console.warn('[pixel] fbq not ready, queueing', event);
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (ready()) {
        clearInterval(timer);
        try { dispatch(event, params, options); } catch { /* noop */ }
      } else if (tries > 40) {
        clearInterval(timer);
        // eslint-disable-next-line no-console
        console.error('[pixel] dropped event, fbq never loaded (blocked?)', event);
      }
    }, 250);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[pixel] track failed', event, e);
  }
}

const FBC_KEY = 'dyssc_fbc';

function readCookies() {
  try {
    return document.cookie.split('; ').reduce((acc, part) => {
      const i = part.indexOf('=');
      if (i > 0) acc[part.slice(0, i)] = decodeURIComponent(part.slice(i + 1));
      return acc;
    }, {});
  } catch { return {}; }
}

// Runs on load: Meta sets _fbc itself on an ad click, but only if fbevents.js
// loaded in time. When it didn't, build fbc from the fbclid in the URL
// (fb.1.<timestamp>.<fbclid>) and keep it so later events still match.
export function captureFbc() {
  try {
    const cookie = readCookies()._fbc;
    if (cookie) {
      localStorage.setItem(FBC_KEY, cookie);
      return cookie;
    }
    const fbclid = new URL(window.location.href).searchParams.get('fbclid');
    if (!fbclid) return localStorage.getItem(FBC_KEY) || null;
    const stored = localStorage.getItem(FBC_KEY);
    if (stored && stored.endsWith(`.${fbclid}`)) return stored;   // same click, keep its timestamp
    const fbc = `fb.1.${Date.now()}.${fbclid}`;
    localStorage.setItem(FBC_KEY, fbc);
    return fbc;
  } catch { return null; }
}

export function getMetaCookies() {
  try {
    const jar = readCookies();
    let fbc = jar._fbc || null;
    if (!fbc) fbc = captureFbc();
    return { fbp: jar._fbp || null, fbc: fbc || null };
  } catch { return { fbp: null, fbc: null }; }
}

export const PIXEL = PIXEL_ID;

// Fires the browser event AND its server-side twin with a shared event_id, so the
// conversion still reaches Meta when the browser beacon is blocked (Meta dedupes).
export async function fbTrackDual(event, params = {}, extra = {}) {
  const eventId = `${event.toLowerCase()}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  fbTrack(event, params, { eventID: eventId });
  try {
    const { fbp, fbc } = getMetaCookies();
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/meta/event`, {
      event_name: event,
      event_id: eventId,
      value: params.value,
      currency: params.currency || 'INR',
      content_ids: params.content_ids || [],
      contents: params.contents || [],
      num_items: params.num_items,
      event_source_url: window.location.href,
      fbp, fbc, ...extra,
    }, { timeout: 8000 });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[pixel] server-side twin failed', event, e?.message);
  }
}
